import styled from "styled-components";

import { MainContainer } from "@/shared/layout/Layout";

export const StyledSVCMainContainer = styled(MainContainer)`
    position: relative;
`;

export const StyledScrollContent = styled.div`
    overflow-y: auto;
`;

export const StyledSVCInputWrapper = styled.div`
    margin-top: 60px;
    margin-bottom: 20px;
    width: 100%;
    .ant-input::placeholder {
        color: ${(props) => props.theme.shelfValueColor};
    }
    .ant-select-selection-placeholder {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }

    .ant-input-wrapper,
    input {
        font-weight: 400;
        font-size: 14px;
        line-height: 120%;
    }

    .ant-input-search-btn {
        background-color: ${(props) => props.theme.collapseHeaderBackground};

        svg {
            fill: ${(props) => props.theme.secondaryBorderColor} !important;
        }
    }
`;

export const StyledSVCList = styled.ul`
    margin-top: 16px;
    padding: 16px;
    border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledSVCListItem = styled.li`
    padding-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;
    border-bottom: 1px solid ${(props) => props.theme.secondaryBorderColor};

    &:last-child {
        border-bottom: none;
        padding-bottom: 0px;
    }
`;
